<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">“The Spirit clearly says that in later times some will abandon the faith and follow deceiving spirits and things taught by demons.”</p>
<p class="fm1"><span>—<i>I Timothy 3:4</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// franmatter01.vue?36b36fae